// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1DyWo","balanceDisclaimer":"posDashboard_balanceDisclaimer__1FSlf"};